import httpClient from "./client";

export const createSpace = async (spaceData) => {
  const response = await httpClient.post("/spaces/", spaceData);
  return response;
};

export const getAllSpaces = async (isActive, sortBy, sortOrder) => {
  const response = await httpClient.get("/spaces/", {
    params: {
      isActive: isActive,
      sortBy,
      sortOrder,
    },
  });
  return response;
};

export const getMembersBySpaceId = async (spaceId) => {
  const response = await httpClient.get(`/spaces/${spaceId}/members`);
  return response;
};

export const deleteSpace = async (spaceId) => {
  const response = await httpClient.patch(`/${spaceId}/deactivate`);
  return response;
};

export const addMemberToSpace = async (spaceId, memberData) => {
  const response = await httpClient.patch(
    `/${spaceId}/add-members`,
    memberData
  );
  return response;
};

export const removeMemberFromSpace = async (chatSpaceId, memberEmail) => {
  const response = await httpClient.patch(
    `/spaces/${chatSpaceId}/members/${memberEmail}/remove`
  );
  return response;
};

export const removeMember = async (email) => {
  const response = await httpClient.patch(
    `/spaces/members/${email}/remove-from-all`
  );
  return response;
};

export const getSpaceById = async (spaceId) => {
  const response = await httpClient.get(`/spaces/${spaceId}`);
  return response;
};

export const updateSpace = async (spaceId, spaceData) => {
  const response = await httpClient.patch(`/spaces/${spaceId}`, spaceData);
  return response;
};
